// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"388":"affiliate","884":"admin"}[chunkId] + "." + {"388":"4d0abab0","884":"56d1ec02"}[chunkId] + ".chunk.js";
};